import type { AppType } from "@zentjes/api"
import { publicEnv } from "@zentjes/config/public-env"
import { hc } from "hono/client"

const getBaseUrl = () => {
    if (typeof window !== "undefined") return ""
    return publicEnv.NEXT_PUBLIC_API_URL ?? publicEnv.NEXT_PUBLIC_APP_URL
}

export const api = hc<AppType>(`${getBaseUrl()}/api/v1`)

export type ApiClient = typeof api
